import { mixpanelClient } from './node-api';

import { useSessionStore } from '@/store/session';

export const trackEvent = (
  name: string,
  payload: Record<string, unknown> = {},
  { once }: { once: boolean } = { once: false },
) => {
  const { sessionId } = useSessionStore();

  mixpanelClient().t.$post({
    json: {
      name,
      sessionId: sessionId.value,
      properties: {
        ...payload,
        ...(once
          ? {
              // Prevent duplicate events by session and event name if needed
              $insert_id: `${sessionId.value}-${name}`,
            }
          : {}),
      },
    },
  });
};

export const identify = ({
  sessionId,
  width,
  height,
  language,
}: {
  sessionId: string;
  width: number;
  height: number;
  language: string;
}) => {
  mixpanelClient().i.$post({
    json: {
      sessionId,
      properties: {
        width,
        height,
        language,
      },
    },
  });
};
